import React, { useState, useEffect } from 'react';
import "./FlagDisplay.css"

const FlagDisplay = () => {
    const [flagData, setFlagData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
       // Function to fetch the flag data from the JSON file
    const fetchFlagData = async () => {
        try {
            // Fetch country flag data from the IP geolocation API
            const ipResponse = await fetch('http://api.ipstack.com/check?access_key=b63f2c3243f3f43226c1482688a94750');
            const ipData = await ipResponse.json();
    
            // Extract the flag data from the API response
            const flagData = {
              name: ipData.country_name,
              svg: ipData.location.country_flag,
              unicode: ipData.location.country_flag_emoji_unicode,
            };
    
            setFlagData(flagData);
            setIsLoading(false);
          } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoading(false);
          }
        };
    
        fetchFlagData();
    }, []);

    if (isLoading) {
        return <div>...</div>;
      }
    
      if (!flagData) {
        return null; // Return null if country code not found in the flag data
      }

      const { svg, name, unicode } = flagData;

    return (
        <div>
            
                <div className='dot' >
                    {/* <p >{name}</p> */}

                    <img src={svg} alt={unicode} className='flag' title={name} />

                </div>
         
        </div>
    );
};

export default FlagDisplay;
